import { ReactNode } from 'react';
import { LoggedInState } from '../../../AnalyticsContext/TrackingData';
import { useAnalytics } from '../../../AnalyticsContext/useAnalytics';
import { useUserData } from '../../../UserProvider/UserProvider';
import {
  Container,
  ExperimentInner,
  Inner as BaseInner,
  NewContainer,
} from './HeaderContainer.styles';

interface Props {
  children?: ReactNode;
  focused?: boolean;
  shorterNavBar?: boolean;
  className?: string;
  Inner?: typeof BaseInner;
  isSearchMultiLine?: boolean;
  topNavExperiment?: boolean;
}

export const HeaderContainer = ({
  children,
  focused,
  className,
  Inner = BaseInner,
  topNavExperiment,
  shorterNavBar,
}: Props) => {
  const user = useUserData();

  useAnalytics({
    userData: {
      loggedIn: user.data ? LoggedInState.LOGGED_IN : LoggedInState.ANONYMOUS,
      userId: user.data?.userId,
      loading: user.loading,
    },
  });

  return (
    <Container focused={focused} className={className} shorterNavBar={shorterNavBar}>
      {topNavExperiment && !shorterNavBar ? (
        <ExperimentInner>{children}</ExperimentInner>
      ) : (
        <Inner>{children}</Inner>
      )}
    </Container>
  );
};

export const NewHeaderContainer = ({
  children,
  focused,
  className,
  Inner = BaseInner,
  isSearchMultiLine,
  topNavExperiment,
  shorterNavBar,
}: Props) => {
  const user = useUserData();

  useAnalytics({
    userData: {
      loggedIn: user.data ? LoggedInState.LOGGED_IN : LoggedInState.ANONYMOUS,
      userId: user.data?.userId,
      loading: user.loading,
    },
  });

  return (
    <NewContainer
      focused={focused}
      className={className}
      shorterNavBar={shorterNavBar}
      isSearchMultiLine={isSearchMultiLine}
    >
      {topNavExperiment && !shorterNavBar ? (
        <ExperimentInner>{children}</ExperimentInner>
      ) : (
        <Inner>{children}</Inner>
      )}
    </NewContainer>
  );
};

export { BaseInner as Inner };
